"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StyledTimepicker = _styledComponents["default"].div.withConfig({
  displayName: "Timepickerstyle__StyledTimepicker",
  componentId: "sc-1q2avso-0"
})(["", ";"], function (props) {
  var position = props.position;
  var _props$theme = props.theme,
    spacing = _props$theme.spacing,
    palette = _props$theme.palette,
    typography = _props$theme.typography,
    _props$theme$extra = _props$theme.extra,
    genericBorderRadius = _props$theme$extra.genericBorderRadius,
    boxShadow = _props$theme$extra.boxShadow;
  var positioningProps;
  switch (position) {
    case 'top':
      positioningProps = 'bottom: calc(100% + 10px);  left: 0; right: 0;';
      break;
    case 'bottom':
      positioningProps = 'top: 40px; left: 0; right: 0;';
      break;
    case 'right':
      positioningProps = 'right: calc(-100% + 30px);';
      break;
    case 'left':
    default:
      positioningProps = 'left: -100%;';
      break;
  }
  return (0, _styledComponents.css)(["display:inline-block;position:relative;input{cursor:pointer;}.icon-ion-android-time{top:-5px;padding:0;cursor:pointer;pointer-events:none;}.timepicker-dropdown{position:absolute;", " z-index:10;padding-bottom:", ";margin-top:-1px;border:none;border-radius:", ";box-shadow:", ";background-color:", ";.header{padding:0 6px;h3{display:flex;align-items:center;justify-content:center;height:44px;font:inherit;font-weight:", ";}.Tabs-container{padding-bottom:", ";.tab-headers{height:", ";.tab-wrapper{> div{padding:0 ", ";font-size:", ";}}}.tabs-active-content{display:none;}}}button{padding:0;color:inherit;font:inherit;outline:inherit;cursor:pointer;border:none;background:none;&:hover,&:focus{background-color:", ";}&.active{background-color:", ";color:", ";&:hover,&:focus{background-color:", ";}}}}"], positioningProps, spacing.xSmall, genericBorderRadius, boxShadow, palette.accent.delta, typography.weight.thick, spacing.small, spacing.base, spacing.base, typography.size.misc, palette.accent.charlie, palette.secondary, palette.basic.white, palette.accent.charlie);
});
StyledTimepicker.displayName = 'StyledTimepicker';
var _default = exports["default"] = StyledTimepicker;